<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Online Menu Snapshots</div>
		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-success m-2" (click)="snapshotPost()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'camera']" size="lg" class="ms-1 me-2"></fa-icon>
						Create Snapshot
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<p-divider></p-divider>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="snapshots"
		[loading]="!snapshots"
		[globalFilterFields]="app.keys(snapshots)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="sortVal">
					<div class="d-flex w-100">
						Date
						<p-sortIcon field="sortVal"></p-sortIcon>
						<p-columnFilter type="date" field="date" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td>
					<div class="d-flex w-100">
						<div class="">
							{{ rec.label }}
						</div>
						<div class="ms-auto">
							<p-button pRipple styleClass="p-button-raised p-button-warning m-2" (click)="restoreSnapshot(rec.value)">
								<ng-template pTemplate="content">
									<div class="d-flex justify-content-center">
										<fa-icon [icon]="['far', 'trash-restore']" size="lg" class="ms-1 me-2"></fa-icon>
										Restore
									</div>
								</ng-template>
							</p-button>
							<p-button
								pRipple
								styleClass="p-button-raised p-button-danger m-2"
								(click)="rekeyFromSnapshot(rec.value)"
								[disabled]="userService.userSubscription.value.role < 5"
							>
								<ng-template pTemplate="content">
									<div class="d-flex justify-content-center">
										<fa-icon [icon]="['far', 'key-skeleton-left-right']" size="lg" class="ms-1 me-2"></fa-icon>
										Rekey from Snapshot
									</div>
								</ng-template>
							</p-button>
						</div>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
